export default {
  user: {
    profile: "Thông tin người dùng",
    user: "Người dùng",
    users: "Người dùng",
    user_list: "Danh sách người dùng",
    role_list: "Danh sách phân quyền",
    username: "Tên đăng nhập",
    name: "Họ và tên",
    email: "Email",
    phone: "Điện thoại",
    add: "Thêm người dùng",
    password: "Mật khẩu",
    repeat_password: "Nhập lại mật khẩu",
    login: "Đăng nhập",
    department: "Phòng Ban",
    position: "Chức Vụ",
    contact: "Thông tin liên lạc"
  }
};
